import { render } from "./DashboardReport.vue?vue&type=template&id=174c4829&scoped=true"
import script from "./DashboardReport.vue?vue&type=script&lang=js"
export * from "./DashboardReport.vue?vue&type=script&lang=js"

import "./DashboardReport.vue?vue&type=style&index=0&id=174c4829&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174c4829"]])

export default __exports__